var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visible,
        width: "1152px",
        "append-to-body": "",
        "before-close": _vm.closedDialog,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c("div", { attrs: { slot: "title" }, slot: "title" }, [
        _c("div", { staticClass: "title-left" }, [
          _c(
            "a",
            {
              staticClass: "title-text link-href",
              attrs: { title: _vm.data.title },
            },
            [_vm._v(" " + _vm._s(_vm.data.title) + " ")]
          ),
          _vm.sentiment
            ? _c(
                "span",
                {
                  staticClass: "common-positive-negative",
                  class: ["is-" + _vm.data.sensitivity],
                },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.sentiment) + " " + _vm._s(_vm.thePercent)
                    ),
                  ]),
                ]
              )
            : _vm._e(),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "info_box" },
        [
          _c("div", [
            _c("span", { staticClass: "title-right source-text mr-8" }, [
              _vm._v(_vm._s(_vm.data.pubdate)),
            ]),
            _c("span", { staticClass: "source-text" }, [
              _vm._v("来源：" + _vm._s(_vm.data.site)),
            ]),
          ]),
          _c("NewsTags", { attrs: { data: _vm.data } }),
          _c("div", { staticClass: "policy-text" }, [
            _c("span", {
              domProps: { innerHTML: _vm._s(_vm.formatText(_vm.data.content)) },
            }),
          ]),
          _vm.data.originalLink
            ? _c(
                "el-link",
                {
                  staticClass: "mt-16",
                  attrs: {
                    href: _vm.data.originalLink,
                    type: "primary",
                    target: "_blank",
                  },
                },
                [_vm._v("查看原文")]
              )
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }